<template>
  <div class="">

    <div class="d-flex justify-content-end">
      <Button v-if="$can( abilities.ADD_PROJECT_FORMALITIES)" @click.prevent="addTable" type="button" btn-class="btn-sm btn-primary ms-3" btn-text="Ajouter un tableau" size="7px 30px"></Button>
    </div>

    <div v-if="model.length || addTableForm.add" class="row mb-5">
      <template v-for="(table, key) in model" :key="key">
        <formalities-table v-if="editingTableFrom.key !== key" :table="table" :deleteTable="deleteTable" :tableKey="key" :editTable="editTable"/>
        <formalities-table-editing v-else :table-key="editingTableFrom.key" :cancelTableModification="cancelTableModification" :deleteLine="deleteLine" :table="editingTableFrom.table" :addLine="addLine" :saveTable="saveEditingTable" :deleteColumn="deleteColumn" :addColumn="addColumn"/>
      </template>
      <div v-if="addTableForm.add && $can( abilities.ADD_PROJECT_FORMALITIES)" class="table-responsive py-5 px-6">
        <div class="d-flex w-50 mb-5 justify-content-between align-items-center">
          <input type="text" placeholder="Entrez ici le nom du tableau" class="form-control form-control-solid text-center"  v-model="addTableForm.table.name" required/>
        </div>

        <table class="formality table-rounded table table-bordered mb-10">
          <thead class="position-relative">
          <tr class="fw-bold fs-6 text-gray-800">
            <th v-for="(column, key) in addTableForm.table.columns" :key="key" class="text-center fw-boldest fs-4 px-6 position-relative">

              <input type="text" placeholder="Entrez ici le nom de la colonne" class="form-control form-control-solid text-center"  v-model="column.name" required/>
              <button
                  class="position-absolute btn btn-light border_button_light py-1 px-3 table_button"
                  type="button"
                  style="top: -12px; right: -15px; z-index: 1;"
                  @click="deleteColumn(addTableForm.table, key)"
                  title="Supprimer cette colonne"
              >
                <i class="fas fa-trash text-danger p-0"></i>
              </button>

              <button
                  class="position-absolute btn btn-light border_button_light py-1 px-3 table_button"
                  type="button"
                  style="bottom: -12px; right: -15px; z-index: 1;"
                  @click="addColumn(addTableForm.table, key)"
                  title="Ajouter une colonne"
              >
                <i class="fas fa-plus text-primary p-0"></i>
              </button>
            </th>
          </tr>
          <button
              class="position-absolute btn btn-light border_button_light py-1 px-3 table_button"
              type="button"
              style="bottom: -12px; left: -15px; z-index: 1;"
              @click="addLine(addTableForm.table)"
              title="Ajouter une ligne"
          >
            <i class="fas fa-plus text-primary p-0"></i>
          </button>
          </thead>
          <tbody>
          <tr v-for="(line, lineKey) in addTableForm.table.lines" class="fw-bold fs-6 text-gray-800 position-relative">
            <td v-for="(column, key) in addTableForm.table.columns" :key="key" class="text-center px-4">
              <input type="text" placeholder="Entrez la valeur" class="form-control form-control-solid text-center"  v-model="line[key]" required/>
            </td>

            <button
                class="position-absolute btn btn-light border_button_light py-1 px-3 table_button"
                type="button"
                style="bottom: -12px; right: -15px; z-index: 1;"
                @click="deleteLine(addTableForm.table, lineKey)"
                title="Supprimer cette ligne"
            >
              <i class="fas fa-trash text-danger p-0"></i>
            </button>

            <button
                class="position-absolute btn btn-light border_button_light py-1 px-3 table_button"
                type="button"
                style="bottom: -12px; left: -15px; z-index: 1;"
                @click="addLine(addTableForm.table, lineKey)"
                title="Ajouter une ligne"
            >
              <i class="fas fa-plus p-0 text-primary"></i>
            </button>
          </tr>
          </tbody>

        </table>

        <div class="d-flex justify-content-end">
          <Button @click.prevent="saveTable(addTableForm.table)" type="button" btn-class="btn-sm btn-primary me-2" btn-text="Enregistrer" size="7px 30px"></Button>
          <Button @click.prevent="cancelTableCreation" type="button" btn-class="btn-sm btn-default text-black me-2" btn-text="Annuler" size="7px 30px"></Button>
        </div>


      </div>
    </div>

    <div v-else>
      <div class="h-350px d-flex justify-content-center align-items-center" >
        <div class=" text-center ">
          <div class="pt-8 ">
            <Img filename="empty.png" alt=""
                 class="mw-100 h-125px h-sm-175px" />
          </div>
          <h2 class="fs-2x fw-bolder mb-0">{{ $t('projects.table.noData') }}</h2>
        </div>
      </div>
    </div>

    <div class="separator my-8"></div>

    <div class="d-flex justify-content-end">
      <Button v-if="$can( abilities.ADD_PROJECT_FORMALITIES)" @click.prevent="addTable" type="button" btn-class="btn-sm btn-primary ms-3" btn-text="Ajouter un tableau" size="7px 30px"></Button>
    </div>
  </div>
</template>

<script setup>
import Button from "@/components/Button.vue";
import Input from "@/components/Input.vue";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import {useSwal} from "@/composables/useSwal";
import {ref} from "vue";
import FormalitiesTable from "@/Modules/Projects/components/FormalitiesTable.vue";
import FormalitiesTableEditing from "@/Modules/Projects/components/FormalitiesTableEditing.vue";
import Img from "@/components/Img.vue";
import moduleAbilities from "@/composables/moduleAbilities";
import abilities from "@/composables/abilities";


const store = useStore()
const route = useRoute()

const {showSwal} = useSwal()

const model = defineModel()

const editingTableFrom = ref({
  key: '',
  table: {}
})

const addTableForm = ref({
  add: false,
  table: {
    name: '',
    columns: [
      {
        name: 'N°'
      }
    ]
  }
})

function cancelTableCreation() {
  addTableForm.value.add = false
  addTableForm.value.table = {
    name: '',
    columns: [
      {
        name: 'N°'
      }
    ]
  }
}

function cancelTableModification() {
  editingTableFrom.value.key = ''
  editingTableFrom.value.table = {}
}

function addTable() {
  addTableForm.value.add = true
  window.scrollTo(0, document.body.scrollHeight);
}

function addColumn(table, key) {
  if(table.lines) {
    table.lines = table.lines.map((line) => {
      line.splice(key + 1, 0, '')
      line = line.map((li) => {
        if(li === null) {
          return ''
        }
        return li
      })
      return line
    })

  }
  table.columns.splice(key + 1, 0, {
    name: ''
  })
}

function addLine(table, key) {
  if(!table.lines) {
    table.lines = []
  }

  if(key === undefined) {
    key = 0
  }else {
    key = key + 1
  }

  let items = table.columns.map(x => '')

  table.lines.splice(key, 0, items)
}

function deleteLine(table, key) {
  showSwal(
      '',
      i18n.global.t('swal.delete_table_line')
  ).then( async (result) => {
    if (result.value) {
      table.lines = table.lines.filter((x,y) => y !== key)
    }
  })
}

function editTable(table, key) {
  editingTableFrom.value.key = key
  editingTableFrom.value.table = JSON.parse(JSON.stringify(table))
}

function saveEditingTable(table, key) {

  if(!table.name.trim()) {
    window.toastr.error('Le nom du tableau est obligatoire')
    return;
  }

  let columns = table.columns.map(x => x.name.trim())

  const hasInvalid = columns.some(item => item === null || item === undefined || item === '');

  if(hasInvalid) {
    window.toastr.error('Le titre de la colonne est obligatoire')
    return;
  }

  let tables = [...model.value]

  tables[key] = table

  store.dispatch('projectSteps/saveProjectTables', {
    project_id: route.params.id,
    tables: tables
  }).then((response) => {
    model.value = tables
    editingTableFrom.value.key = ''
    editingTableFrom.value.table = {}
  })
}

function saveTable(table) {

  if(!table.name.trim()) {
    window.toastr.error('Le nom du tableau est obligatoire')
    return;
  }

  let columns = table.columns.map(x => x.name.trim())

  const hasInvalid = columns.some(item => item === null || item === undefined || item === '');

  if(hasInvalid) {
    window.toastr.error('Le titre de la colonne est obligatoire')
    return;
  }

  let tables = [...model.value]

  tables.push(table)

  store.dispatch('projectSteps/saveProjectTables', {
    project_id: route.params.id,
    tables: tables
  }).then((response) => {
    model.value.push(table)
    addTableForm.value.add = false
    addTableForm.value.table = {
      name: '',
      columns: [
        {
          name: 'N°'
        }
      ]
    }
  })
}

function deleteColumn(table, key) {
  if(table.columns.length > 1) {
    showSwal(
        '',
        i18n.global.t('swal.delete_table_column')
    ).then( async (result) => {
      if (result.value) {
        table.columns = table.columns.filter((x,y) => y !== key)
      }
    })
  }
}

function deleteTable(key) {
  let tables = JSON.parse(JSON.stringify(model.value))
  tables = tables.filter((x,y) => y !== key)

  showSwal(
      '',
      i18n.global.t('swal.delete_table')
  ).then( async (result) => {
    if (result.value) {
      store.dispatch('projectSteps/saveProjectTables', {
        project_id: route.params.id,
        tables: tables
      }).then((response) => {
        model.value = model.value.filter((x,y) => y !== key)
      })
    }
  })
}
</script>

<style scoped>
.formality.table {
  --bs-table-color: #212529;
  --bs-table-bg: transparent;
  --bs-table-border-color: #dee2e6;
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: #212529;
  --bs-table-striped-bg: rgba(0, 0, 0, 0.05);
  --bs-table-active-color: #212529;
  --bs-table-active-bg: rgba(0, 0, 0, 0.1);
  --bs-table-hover-color: #212529;
  --bs-table-hover-bg: rgba(0, 0, 0, 0.075);
  width: 100%;
  margin-bottom: 1rem;
  color: var(--bs-table-color);
  vertical-align: top;
  border-color: var(--bs-table-border-color);
  border-collapse: collapse;
}

.border_button_light {
  border: 1px solid #dee2e6 !important;
}

.formality.table-bordered > :not(caption) > * {
  border-width: 1px 1px;
  border-style: solid;
  border-color: var(--bs-table-border-color);
}

.formality.table-bordered th,
.formality.table-bordered td {
  border: 1px solid #dee2e6;
}

.formality.table-bordered tbody tr:last-child {
  border-bottom: 1px solid var(--bs-table-border-color) !important;
}

.table_button {
  opacity: 0;
}

.formality:hover .table_button{
  opacity: 1;
}

.table_button:hover {
  opacity: 1 !important;
}

</style>